import { t, SupportedLocale } from "@/lib/i18n";
import { Layout } from "@/components/Layout";
import { SEO } from "@/components/SEO";
import { LatestProductsSection } from "@/components/LatestProductsSection";
import { getHomeUrl, getAllProductsUrl } from "@/lib/urls";
import styles from "@/styles/NotFound.module.css";

type NotFoundProps = {
  locale: SupportedLocale;
  /** Custom message key, e.g. "notFound.product" */
  messageKey?: "notFound.page" | "notFound.product" | "notFound.category" | "notFound.subcategory";
};

export function NotFound({ locale, messageKey = "notFound.page" }: NotFoundProps) {
  return (
    <div className={styles.page}>
      <SEO title="404" noIndex />
      <Layout>
        <main className={styles.main}>
          <section className={styles.section}>
            <div className={styles.card}>
              <span className={styles.code}>404</span>
              <h1 className={styles.title}>{t(locale, "notFound.title")}</h1>
              <p className={styles.message}>{t(locale, messageKey)}</p>
              <div className={styles.actions}>
                <a href={getHomeUrl(locale)} className={styles.primaryBtn}>
                  {t(locale, "notFound.backHome")}
                </a>
                <a href={getAllProductsUrl(locale)} className={styles.secondaryBtn}>
                  {t(locale, "nav.products")}
                </a>
              </div>
            </div>
          </section>

          <LatestProductsSection
            locale={locale}
            variant="compact"
            titleId="notfound-latest-title"
          />
        </main>
      </Layout>
    </div>
  );
}
